import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Forbidden } from '@/pages/Forbidden';

export interface RequireRoleProps {
  allow: readonly string[];
  children: ReactNode;
}

export function RequireRole({ allow, children }: RequireRoleProps) {
  const { user } = useAuth();
  if (!user || !allow.includes(user.role)) {
    return <Forbidden />;
  }
  return <>{children}</>;
}
